export default "__VITE_ASSET__09ZLwr$P__"